import React from 'react';
import { Provider } from 'react-redux';
import store from 'store';
import Routes from 'routes';
// import ReactGA from 'react-ga';
// ReactGA.initialize('UA-234060563-1');
// ReactGA.pageview(window.location.pathname + window.location.search);

export default function App() {
    return (
        <Provider store={store}>
            <Routes />
        </Provider>
    );
}